import {
  ClaimTypes,
  Determination,
} from 'services/ClaimscoreApiService/shared/types';

export type FiltersForm = {
  startDate?: string;
  endDate?: string;
  determinations?: Determination[];
  deductionCodes?: string[];
  claimTypes?: ClaimTypes[];
  unitRange?: [number, number];
  payoutRange?: [number, number];
  scoreRange?: [number, number];
  useRealTimeClaims?: boolean;
  files?: string[];
  claimscoreResult?: string[];
  submissionType?: string[];
  accessType?: string[];
  claimEvidenceProvided?: string[];
  claimantEntityType?: string[];
};

export enum ExportType {
  Insight = 'insight',
  Raw = 'raw',
}

export type ExportsForm = {
  title?: string;
};

export enum DrawerType {
  'Filter',
  'Export',
  'ShareReport',
  'ScheduleReport',
  'Timeframe',
}
export enum PayoutDrawerType {
  'Payout',
  'ClassMembers',
  'Units',
}

export enum OverviewCardDrawerType {
  'ApprovedClaims',
  'RejectedClaims',
  'NotAnalyzed',
}

export const clearFormValues: FiltersForm = {
  determinations: [],
  deductionCodes: [],
  claimTypes: [],
  useRealTimeClaims: true,
  files: [],
  unitRange: undefined,
  payoutRange: undefined,
  scoreRange: undefined,
  claimscoreResult: [],
  submissionType: [],
  accessType: [],
  claimEvidenceProvided: [],
  claimantEntityType: [],
};

export enum PermissionsType {
  Organization = 'organization',
  Case = 'case',
}

export enum AccountStatus {
  Active = 'active',
  Pending = 'pending_2fa',
}
